import classes from './notification.module.css'

import { type MantineTheme } from '@mantine/core'

type NotificationVarsProps = {
  color?: string
  loading?: boolean
}

const DARK_FILLED_SHADE: Record<string, number> = {
  red: 6,
}

const notificationVars = (theme: MantineTheme, props: NotificationVarsProps) => {
  if (props.loading) {
    return {
      root: {
        '--notification-bg': 'var(--mantine-color-surface-2)',
        '--notification-border-color': 'var(--mantine-color-border-surface)',
      },
    }
  }

  const name = (props.color ?? theme.primaryColor).split('.')[0]
  const darkFilledShade = DARK_FILLED_SHADE[name] ?? 7

  return {
    root: {
      '--notification-bg': `light-dark(var(--mantine-color-${name}-0), var(--mantine-color-${name}-10))`,
      '--notification-border-color': `light-dark(var(--mantine-color-${name}-2), var(--mantine-color-${name}-9))`,
      '--notification-color': `light-dark(var(--mantine-color-${name}-5), var(--mantine-color-${name}-${darkFilledShade}))`,
    },
  }
}

const Notification = {
  defaultProps: {
    radius: 'xl',
    withBorder: true,
    withCloseButton: true,
    loaderProps: { size: 22 },
  },
  classNames: {
    root: classes.root,
    icon: classes.icon,
    loader: classes.loader,
    body: classes.body,
    title: classes.title,
    description: classes.description,
    closeButton: classes.closeButton,
  },
  vars: notificationVars,
}

export default Notification
